import React from 'react';
import { History } from 'history';
import { Input, InputNumber, InputMultiline, InputFile, InputPicklist} from '../../components';
import BaseDelete from '../base/base-delete.component'; 
import Model from './quizanswer-model';  //editable..
import QuizresultChecklist from '../quizresult/quizresult-checklist.component';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class QuizanswerDelete extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }
    
    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseDelete history={this.props.history} 
                model={Model} onLoad={this.onLoad}>              
                
                <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                <Input name='title' label='Title' value={this.state.datarow.title} readOnly/>
                <InputMultiline name='content' label='Content' value={this.state.datarow.content} readOnly/>
                <InputFile name='imageUrl' label='Image' value={this.state.datarow.imageUrl} type='image' readOnly/>
                <InputNumber name='seq' label='Seq' value={this.state.datarow.seq} readOnly/>
                <Input name='answer' label='Answer' value={this.state.datarow.answer} readOnly/>
                <InputNumber name='value' label='Value' value={this.state.datarow.value} readOnly/>
                <InputPicklist name='quizresult' label='Quiz Result List' value='' caption={this.state.datarow.quizresultCaption} readOnly={this.state.datarow.quizresult? false: true} disableAutoClose>
                    <QuizresultChecklist history={this.props.history} currentId={this.state.datarow.quizresult} readOnly disableBackButton/>
                </InputPicklist>                   
            </BaseDelete>
            );
    }
}